// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import $ from 'jquery';

export default class EshopGalleryPopup extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	enterDocument() {
		this.on('click', this.handleClick);
	}
	handleClick(e) {
		const {
			item,
		} = this.props;

		e.preventDefault();
		CursorSpinner.pushToQueue('showEshopGalleryPopup');

		let targetUrl = window.location.href;
		if (targetUrl.indexOf('?') === -1) {
			targetUrl += '@gallery?ramJetLayoutContext=galleryPopup&activeItem=' + item;
		} else {
			targetUrl = targetUrl.replace('?', '@gallery?ramJetLayoutContext=galleryPopup&activeItem=' + item + '&');
		}

		$.get(targetUrl, (data) => {
			CursorSpinner.removeFromQueue('showEshopGalleryPopup');
			try {
				window.edeeshopPopup.createPopup(data, 'esp-eshop-gallery');
			} catch (ex) {
				console.error(`'ESP is not accessible from 'window'`, ex);
				// check js/windowExports.js or import it directly from fg-frontend
			}
		});
	};
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopGalleryPopup.js